import React from 'react';
import { FaTimes, FaClock, FaCalendarAlt, FaExclamationCircle } from 'react-icons/fa';

const TradingHoursModal = ({ isOpen, onClose, dayType }) => {
  if (!isOpen) return null;

  const getDayTypeMessage = () => {
    switch(dayType) {
      case 'weekend':
        return {
          title: 'Market Closed - Weekend',
          icon: <FaCalendarAlt className="text-4xl text-orange-500" />,
          message: 'Today is a weekend. The Indian stock market is closed on Saturdays and Sundays.'
        };
      case 'holiday':
        return {
          title: 'Market Closed - Holiday',
          icon: <FaCalendarAlt className="text-4xl text-blue-500" />,
          message: 'Today is a market holiday. The Indian stock market is closed today.'
        };
      case 'after_hours':
        return {
          title: 'Market Closed - After Trading Hours',
          icon: <FaClock className="text-4xl text-purple-500" />,
          message: 'Trading hours have ended for today. The market is closed outside of trading hours.'
        };
      case 'before_hours':
        return {
          title: 'Market Not Open Yet',
          icon: <FaClock className="text-4xl text-indigo-500" />,
          message: 'The market has not opened yet today. Trading starts at 9:15 AM.'
        };
      default:
        return {
          title: 'Market Closed',
          icon: <FaExclamationCircle className="text-4xl text-gray-500" />,
          message: 'The market is currently closed.'
        };
    }
  };

  const dayInfo = getDayTypeMessage();

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-2xl max-w-md w-full animate-fade-in">
        {/* Header */}
        <div className="relative bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-5 rounded-t-xl">
          <h2 className="text-xl font-bold pr-8">{dayInfo.title}</h2>
          <button
            onClick={onClose}
            className="absolute top-5 right-5 text-white hover:text-gray-200 transition-colors"
          >
            <FaTimes className="text-xl" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          {/* Icon */}
          <div className="flex justify-center mb-4">
            <div className="w-20 h-20 bg-gray-50 rounded-full flex items-center justify-center">
              {dayInfo.icon}
            </div>
          </div>

          {/* Message */}
          <p className="text-center text-gray-700 mb-6 text-base">
            {dayInfo.message}
          </p>

          {/* Trading Hours Info Box */}
          <div className="bg-gradient-to-br from-blue-50 to-indigo-50 border-2 border-blue-200 rounded-lg p-5 mb-6">
            <h3 className="font-bold text-blue-900 mb-3 text-center text-lg">
              📊 Indian Market Trading Hours
            </h3>
            
            <div className="space-y-3">
              <div className="flex items-center justify-between bg-white rounded-lg p-3 shadow-sm">
                <div className="flex items-center gap-2">
                  <FaCalendarAlt className="text-green-600" />
                  <span className="font-semibold text-gray-900 text-sm">Trading Days</span>
                </div>
                <span className="text-green-600 font-bold text-sm">Monday - Friday</span>
              </div>

              <div className="flex items-center justify-between bg-white rounded-lg p-3 shadow-sm">
                <div className="flex items-center gap-2">
                  <FaClock className="text-blue-600" />
                  <span className="font-semibold text-gray-900 text-sm">Trading Hours</span>
                </div>
                <span className="text-blue-600 font-bold text-sm">9:15 AM - 3:30 PM</span>
              </div>

              <div className="flex items-center justify-between bg-white rounded-lg p-3 shadow-sm">
                <div className="flex items-center gap-2">
                  <FaCalendarAlt className="text-red-600" />
                  <span className="font-semibold text-gray-900 text-sm">Market Closed</span>
                </div>
                <span className="text-red-600 font-bold text-sm">Weekends & Holidays</span>
              </div>
            </div>
          </div>

          {/* Info Note */}
          <div className="bg-amber-50 border-l-4 border-amber-500 p-4 rounded-r-lg mb-4">
            <div className="flex items-start gap-2">
              <FaExclamationCircle className="text-amber-600 mt-1 flex-shrink-0" />
              <p className="text-sm text-amber-900">
                <strong>Note:</strong> You can only run scans during market hours on trading days. 
                Please try again when the market is open.
              </p>
            </div>
          </div>

          {/* Close Button */}
          <button
            onClick={onClose}
            className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white font-semibold py-3 px-6 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl"
          >
            Got It
          </button>
        </div>
      </div>
    </div>
  );
};

export default TradingHoursModal;

